import React from 'react'
import i18n from 'Pods/Shared/I18n'
import { bool, string } from 'prop-types'

function CustomModelRequestCard({ locale, isAlone }) {
  const customModelRequestCardStyles = {
    contain: { maxWidth: '100%' },
    wrapText: { whiteSpace: 'normal' },
    columns: isAlone
      ? 'col-12 col-sm-6 col-md-4 col-lg-3 col-xxl-2'
      : 'col-6 col-md-4 col-lg-3 col-xxl-2',
  }

  return (
    <div className={customModelRequestCardStyles.columns}>
      <div className="content-box is-no-results-box content-box--interactive">
        <div className="content-box__content no-results">
          <div
            className="l-inner-compact"
            style={customModelRequestCardStyles.contain}
          >
            <div className="content-text u-text-center">
              {i18n.t('items.last_card.text', {
                ns: 'rails',
                lng: locale,
              })}
            </div>
            <div className="content-action u-text-center">
              <a
                href="/3d-modeling-jobs/hire-freelancers"
                className="btn btn-primary btn-sm btn-fat"
                style={customModelRequestCardStyles.wrapText}
              >
                {i18n.t('items.last_card.button_text', {
                  ns: 'rails',
                  lng: locale,
                })}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CustomModelRequestCard.propTypes = {
  locale: string.isRequired,
  isAlone: bool.isRequired,
}

export default CustomModelRequestCard
